function initializeOnefrCollections(root = document) {
  root.querySelectorAll('[data-onefr-collection-redirect]').forEach(section => {
    const path = section.dataset.onefrCollectionRedirect;
    if (!path || !path.startsWith('/collections/')) return;
    const destination = new URL(window.location.href);
    if (destination.pathname === path) return;
    destination.pathname = path;
    destination.searchParams.delete('page');
    window.location.replace(destination.toString());
  });
  root.querySelectorAll('[data-onefr-sort]').forEach(form => {
    if (form.dataset.enhanced) return;
    form.dataset.enhanced = 'true';
    form.addEventListener('change', event => {
      if (event.target.name !== 'sort_by') return;
      const destination = new URL(window.location.href);
      destination.searchParams.set('sort_by', event.target.value);
      destination.searchParams.delete('page');
      destination.hash = 'collection-products';
      window.location.assign(destination.toString());
    });
  });
}
initializeOnefrCollections();
document.addEventListener('shopify:section:load', event => initializeOnefrCollections(event.target));
